//
// forms/js-mkto-form-ui.js - UI controller for a standard marketo form
//
// Subscribes to the following Form/ events:
//  - ValidityUpdate
//  - BeginSubmission
//  - CancelSubmission
//  - EndSubmission
//
// Generally, should do only two things:
//  - Set appropriate error messages using the data- attributes on elements
//  - Switch classes on element (for validity or submission state)
//

import Q   from '../AnimQueue';
import loc from '../localise';
import * as validity from './validity';
import {curry, reverse_curry} from '../helpers/functional';

var cl_invalid__c_validation = 's-validation-error';
var cl_valid__c_validation = 's-validation-ok';


// ValidityUpdate
// ----------------------------------

function validity_update(el_form, event) {
  var vdc = event.detail;
  vdc.forEach((v_obj) => validity_update__element(v_obj[0], v_obj[1]));
}

function validity_update__element(el_div, val_obj) {
  var el_wrapper = el_div.getElementsByClassName('c-form-set__inner')[0];
  var el_msg    = el_div.getElementsByClassName('c-validation-msg__text')[0];

  if (el_wrapper) {
    if (val_obj.ok) {
      el_wrapper.classList.remove(cl_invalid__c_validation);
      el_wrapper.classList.add(cl_valid__c_validation);
    }
    else {
      el_wrapper.classList.remove(cl_valid__c_validation);
      el_wrapper.classList.add(cl_invalid__c_validation);
    }
  }

  el_msg.innerHTML = get_error_message(el_div, val_obj);
}

function get_error_message(el_div, val_obj) {
  if (val_obj.ok) {
    return '';
  }

  if (val_obj.reason === validity.REASON.Required) {
    return loc('This field is required', {strings: window.__localisations__forms});
  }

  if (val_obj.reason === validity.REASON.InvalidFormat) {
    const msg = el_div.getAttribute('data-validation-msg');
    return msg || loc('Invalid format', {strings: window.__localisations__forms});
  }

  if (val_obj.reason === validity.REASON.OutOfRange) {
    const el_input = el_div.getElementsByClassName('js-input')[0];
    const min = el_input.getAttribute('min');
    const max = el_input.getAttribute(el_input, 'max');
    if (min !== null && max !== null) {
      return loc('Must be between XXX and YYY', {strings: window.__localisations__forms})
        .replace('XXX', min)
        .replace('YYY', max);
    }
    if (min !== null) {
      return loc('Must be at least XXX', {strings: window.__localisations__forms})
        .replace('XXX', min);
    }
    if (max !== null) {
      return loc('Must be at most XXX', {strings: window.__localisations__forms})
        .replace('XXX', max);
    }
  }

  if (val_obj.reason === validity.REASON.NotBusinessy) {
    return loc('Please enter a business email address', {strings: window.__localisations__forms});
  }

  if (val_obj.reason === validity.REASON.NotFullName) {
    return loc('Please enter your full name', {strings: window.__localisations__forms});
  }
}


// BeginSubmission
// ----------------------------------

const cl__btn_standing  = 'c-btn--standing';
const cl__btn_loading   = 'c-btn--loading';
const cl__btn_error     = 'c-btn--error';
const cl__btn_confirmed = 'c-btn--confirmed';
const cls_btn_states = [
  cl__btn_standing, cl__btn_loading, cl__btn_error, cl__btn_confirmed,
];

function begin_submission(el_form, event) {
  Q(get_btn(el_form))
    .stop()
    .q(reverse_curry(btn_set, cl__btn_loading));

  let confirmation_msg = el_form.getElementsByClassName('c-form-confirmation')[0];
  if (confirmation_msg) {
    confirmation_msg.classList.add('dn'); 
  }
}


// CancelSubmission
// ----------------------------------

function cancel_submission(el_form, event) {
  Q(get_btn(el_form))
    .stop()
    .q(reverse_curry(btn_set, cl__btn_error), 1200)
    .q(reverse_curry(btn_set, cl__btn_standing));

  let confirmation_msg = el_form.getElementsByClassName('c-form-confirmation')[0];
  if (confirmation_msg) {
    confirmation_msg.classList.add('dn'); 
  }
}


// EndSubmission
// ----------------------------------

function end_submission(el_form, event) {
  Q(get_btn(el_form))
    .stop()
    .q(reverse_curry(btn_set, cl__btn_confirmed), 1200)
    .q(reverse_curry(btn_set, cl__btn_standing));
  
  let confirmation_msg = el_form.getElementsByClassName('c-form-confirmation')[0];
  if (confirmation_msg) {
    confirmation_msg.classList.remove('dn'); 
  }
}


// Button-related helpers
// ----------------------------------

function btn_set(el_btn, c) {
  cls_btn_states.forEach(c => el_btn.classList.remove(c));
  el_btn.classList.add(c);
}
function get_btn(el_form) {
  return el_form.getElementsByClassName('c-btn')[0];
}


export default function init(el_form) {
  if (el_form.tagName !== 'FORM') {
    throw Error('Initialised on non-form element', 'forms/js-mkto-form-ui.js');
  }

  // Subscribe to events
  el_form.addEventListener('Form/ValidityUpdate', curry(validity_update, el_form));
  el_form.addEventListener('Form/BeginSubmission', curry(begin_submission, el_form));
  el_form.addEventListener('Form/CancelSubmission', curry(cancel_submission, el_form));
  el_form.addEventListener('Form/EndSubmission', curry(end_submission, el_form));
}
